module.exports = __webpack_public_path__ + "static/media/paper-money-two.92f81ebe.svg";